function faqHandler(className = 'faq-block-item') {
  const faqItems = document.getElementsByClassName(className);

  for (let item of faqItems) {
    const head = item.getElementsByClassName('faq-block-item-head')[0];
    const body = item.getElementsByClassName('faq-block-item-body')[0];

    head.addEventListener('click', () => {
      // Если элемент скрыт, показываем его
      if (body.style.height === '0px' || !body.style.height) {
        const correctHeight = body.scrollHeight + 30;

        // Устанавливаем высоту элемента на его фактическую высоту для анимации
        body.style.height = correctHeight + 'px';
        body.style.opacity = 1;
        body.style.paddingTop = '15px';
        body.style.paddingBottom = '15px';

        // После завершения анимации оставляем фиксированное значение, чтобы элемент оставался открытым
        /*setTimeout(() => {
          body.style.height = 'auto';
        }, 300);*/
      } else {
        // Сначала устанавливаем фиксированную высоту для плавного закрытия
        body.style.height = body.scrollHeight + 'px';

        // Анимируем уменьшение высоты до 0
        setTimeout(() => {
          body.style.height = '0px';
          body.style.opacity = 0;
          body.style.paddingTop = '0px';
          body.style.paddingBottom = '0px';
        }, 10);
      }
    });
  }
}

export default faqHandler;
